// Web training API — for logged-in users completing their own training
import { getSessionUUID } from '../components/lib/AuthToken';

const h = async () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${await getSessionUUID()}`,
});

export const fetchMyTraining = async () => {
    try {
        const r = await fetch('/training/web/my-training', { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const fetchTrainingModuleForWeb = async (moduleId) => {
    try {
        const r = await fetch(`/training/web/module/${moduleId}`, { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const fetchTrainingContentUrl = async (moduleId) => {
    try {
        const r = await fetch(`/training/web/module/${moduleId}/content-url`, { headers: await h(), credentials: 'include' });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};

export const submitTrainingAttemptWeb = async (moduleId, answers) => {
    try {
        const r = await fetch('/training/web/attempt/submit', {
            method: 'POST', credentials: 'include',
            headers: await h(),
            body: JSON.stringify({ module_id: moduleId, answers }),
        });
        return await r.json();
    } catch (e) { return { error: e.message }; }
};
